import type { ComponentProps } from "react";
import type { SanitySiteSettingsNavigation } from "@ouster/shared";
import { AppLayout } from "~/features/app/app-layout";
import { adaptSanitySiteSettingsToAppLayoutCommon } from "./adapter";
type AppLayoutProps = ComponentProps<typeof AppLayout>;
type SanityAdaptedAppLayoutProps = Omit<AppLayoutProps, "common" | "customLogo" | "pageNavAdditionalLinks" | "supportLink"> & {
  customLogo?: unknown;
  pageNavAdditionalLinks?: unknown[];
  siteSettings?: SanitySiteSettingsNavigation | null;
  supportLink?: unknown;
};
export type SanityAppLayoutProps = SanityAdaptedAppLayoutProps;
export function SanityAppLayout({
  siteSettings,
  ...props
}: SanityAppLayoutProps) {
  return <AppLayout {...props as AppLayoutProps} common={adaptSanitySiteSettingsToAppLayoutCommon(siteSettings) as AppLayoutProps["common"]} />;
}
export * from "./adapter";